export interface ImagesGalleryProps {
  gallery: string[]
}

export const useImagesGallery = (props: ImagesGalleryProps) => {
  return {
    ...props,
  }
}
